// Values come from the "FATA Dashboard App" .ionapi file (ION API Gateway > Authorized Apps).
// The client secret (cs) is intentionally NOT used - this app runs in the browser and signs in
// with the OAuth2 implicit grant, which only needs the client ID.
const ionApi = {
  tenant: 'BT6URH9MCA349B9W_PRD',                                              // ti
  clientId: 'BT6URH9MCA349B9W_PRD~m1QvdcQo6pVF3qoDfOM04C2u6L5PUnDfm8ELi7hGw-U', // ci
  gatewayUrl: 'https://mingle-ionapi.inforcloudsuite.com',                     // iu
  authServerUrl: 'https://mingle-sso.inforcloudsuite.com/BT6URH9MCA349B9W_PRD/as/', // pu
  authorizeEndpoint: 'authorization.oauth2',                                   // oa
};

// The redirect URL must also be registered on the Authorized App (Redirect URL list),
// and the origin in Authorized JavaScript Origins.
const redirectUrl = window.location.origin + (process.env.PUBLIC_URL || '') + '/callback';

export default {
  ionApi: ionApi,
  redirectUrl: redirectUrl,

  // Mongoose REST (v1 JSON) through the ION API gateway
  restBaseUrl: `${ionApi.gatewayUrl}/${ionApi.tenant}/CSI/IDORequestService/MGRestService.svc/json/`,

  // Mongoose REST v2 load. Used for all reads: v1 puts the property list in the URL path,
  // which IIS limits to 260 characters (the OPNR SLPoItems list is longer).
  idoLoadUrl: `${ionApi.gatewayUrl}/${ionApi.tenant}/CSI/IDORequestService/ido/load/`,

  // Cloud configurations offered at login (on-prem these were FAI and FAM)
  configurations: [
    'BT6URH9MCA349B9W_PRD_FAI',
    'BT6URH9MCA349B9W_PRD_FAM',
  ],

  // SyteLine web client in the Infor OS portal. The report buttons open forms here;
  // favoriteContext takes a form spec, e.g. FormName(SETVARVALUES(...)FILTER(...)).
  // The site is whichever one the user has selected in the web client, not a URL parameter.
  sytelineWebClient: {
    portalUrl: `https://mingle-portal.inforcloudsuite.com/${ionApi.tenant}/05d392c3-4ea0-4c9f-8a60-8e5905bdbe32`,
    logicalId: 'lid://infor.syteline.csi',
  },
};
